export const loginUser = (user) => {
  localStorage.setItem("adminSession", JSON.stringify(user));
};

export const logoutUser = () => {
  localStorage.removeItem("adminSession");
  window.location.href = "/admin_login";
};

export const getSession = () => {
  const session = localStorage.getItem("adminSession");
  if(session){
    return JSON.parse(session);
  }
  else{
    window.location.href = "/admin_login";
  }
  
};
